import styled from 'styled-components'

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default IconWrapper
